import React from 'react'
import Slider from 'react-slick'

import { PropertyData } from '../common/models/properties'
import { PropertyInfo, PropertyPath } from '../common/components/property'

interface FeaturedProps {
  properties: PropertyData[]
  guest?: boolean
}

interface FeaturedState {

}

export default class Featured extends React.Component<FeaturedProps, FeaturedState> {
  render() {
    const { properties, guest } = this.props

    const sliderSettings = {
      arrows: false,
      dots: true,
      infinite: true,
      slidesToScroll: 1,
      autoplay: true,
      autoplaySpeed: 6000,
      pauseOnHover: true
    }

    return (
      <Slider {...sliderSettings}>
        { properties.map((p, i) => {
          return (
            <div key={i} className="featured-property">
              <div className="row">
                <div className="large-6 medium-12 small-12 columns">
                  <a href={ PropertyPath(p) }>
                    <div className="featured-property__image" style={{ 'backgroundImage': `url('${p.full_image}')` }}>
                    </div>
                  </a>
                </div>

                <div className="large-6 medium-12 small-12 columns">
                  <PropertyInfo property={p} guest={guest} combinedTitle={true} />
                </div>
              </div>
            </div>
          )
        }) }
      </Slider>
    )
  }
}